import { Chip, TextField, Typography } from '@mui/material';
import { trackEventMatomo } from '../../helpers/matomo';
import { useMask } from '@react-input/mask';
import { SubItemFormFilling } from '../Filling/Types';
import { useContext, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import CheckIcon from './CheckIcon';
import AdditionalInfo from './Structure/AdditionalInfo';
import { NewWebFormContext } from '../../context/NewWebFormContext';

type Props = {
  value: string | string[] | null;
  setValue: Function;
  tipo: string;
  multiple?: boolean;
  type?: string | null;
  lista?: string[] | null;
  setLista?: Function;
  required?: boolean;
  subitem: SubItemFormFilling,
};

export default function TextFieldComp({
  value,
  setValue,
  tipo,
  multiple,
  type,
  required,
  subitem,
}: Props) {
  const { ForceUpdate } = useContext(NewWebFormContext);

  const telefoneRef = useMask({ mask: '__ ____-_____', replacement: { _: /\d/ } });
  const rgRef = useMask({ mask: '__.___.___-_', replacement: { _: /\d/ } });
  const cepRef = useMask({ mask: '_____-___', replacement: { _: /\d/ } });
  // const cpfRef = useMask({ mask: value?.length as number > 14 ? '__.___.___/____-__' : '___.___.___-__', replacement: { _: /\d/ } });

  const textFieldTitle: string = (() => {
    let title = '';
    if(CheckIcon(subitem, value) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  function inputRefSelect(type: string) {
    switch (type) {
      case 'telefone': return telefoneRef;
      case 'rg': return rgRef;
      case 'cep': return cepRef;
      // case 'cpfcnpj': return cpfRef;
      default: return null;
    }
  }

  const maxLenght = `${value?.length === undefined ? 0 : value.length}/1000`;

  const checkItem = (tipo: string) => {
    const image = subitem.foto;
    const text = subitem.comentario;
    if (image || text) {
      switch (tipo) {
        case 'telefone':
          if ([12, 13].includes(value?.length as number)) {
            return (<AdditionalInfo subItem={subitem} />);
          }
          break;
        case 'rg':
          if ([10, 12].includes(value?.length as number)) {
            return (<AdditionalInfo subItem={subitem} />);
          }
          break;
        case 'cep':
          if ([9].includes(value?.length as number)) {
            return (<AdditionalInfo subItem={subitem} />);
          }
          break;
        // case 'cpfcnpj':
        //   if ([14, 18].includes(value?.length as number)) {
        //     return (<AdditionalInfo subItem={subitem} />)
        //   }
        //   break;
        case 'numero':
          const max = Number(subitem.maxNumberVal);
          const min = Number(subitem.minNumberVal);
          if (min || max) {
            if (Number(value) >= Math.max(min) && Number(value) <= Math.min(max)) {
              return (<AdditionalInfo subItem={subitem} />);
            }
          } else if (value !== null) {
            return (<AdditionalInfo subItem={subitem} />);
          }
          break;
        case 'email':
          const regexEmail = /^(?![.-])([A-Za-z0-9._%+-]+(?:(?<=.)[A-Za-z0-9._%+-]))@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/;
          if (regexEmail?.test(value as string)) {
            return (<AdditionalInfo subItem={subitem} />);
          }
          break;
        default: return (value && <AdditionalInfo subItem={subitem} />);

      }
    }
  };

  useEffect(() => {
    if (subitem.ocorrencia) {
      setValue(subitem.ocorrencia);
    }
  }, []);

  useEffect(() => {
    if (subitem.padrao) {
      setValue(subitem.padrao);
      subitem.ocorrencia = subitem.padrao;
    }
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    }
  }, []);

  useEffect(() => {
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    } else if (!value) {
      delete subitem.checked;
    }
    ForceUpdate();
  }, [value]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <TextField
        inputProps={{
          maxLength: `${(subitem.tipo === 'textoCurto' && 200) || (subitem.tipo === 'textoLongo' && 1000)}`,
        }}
        InputProps={{
          endAdornment: (
            <>
              {subitem.minNumberVal &&
                <>
                  <Avatar color='danger' variant="square">
                    Min
                  </Avatar>
                  <Chip label={subitem.minNumberVal} />
                </>
              }{subitem.maxNumberVal &&
                <>
                  <Avatar color='danger' variant="square">
                    Max
                  </Avatar>
                  <Chip label={subitem.maxNumberVal} />
                </>
              }
            </>
          ),
        }}
        required={required}
        className={`${subitem.itemid}|${subitem.id}`}
        helperText={`${subitem.tipo === 'textoLongo' ? maxLenght : ''}`}
        fullWidth
        type={type as string}
        multiline={multiple}
        inputRef={inputRefSelect(tipo)}
        value={value}
        onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edita valor')}
        onChange={(event) => {
          setValue(event.target.value);
          subitem.ocorrencia = event.target.value;
          if (!event.target.value?.length) {
            delete subitem.ocorrencia;
          }
        }}
        sx={{
          height: '100%',
          backfaceVisibility: 'hidden',
        }}
      />
      {checkItem(subitem.tipo)}
    </>
  );
}